import { createContext, useContext, useEffect } from 'react';

export type UserState = {
    accessToken?: string;
    refreshToken?: string;
    operatorId?: string;
};

export type UserStateActions = {
    setAuth: (accessToken: string, operatorId?: string) => void;
};

export const UserStateContext = createContext<[UserState, React.Dispatch<React.SetStateAction<UserState>>]>([
    {},
    () => {},
]);

export const useUserState = (): UserState & UserStateActions => {
    const [auth, setAuthState] = useContext(UserStateContext);

    // Restore from localStorage on mount
    useEffect(() => {
        const saved = localStorage.getItem('userState');
        if (saved) {
            const parsed = JSON.parse(saved);
            setAuthState((curr) => ({ ...curr, ...parsed }));
        }
    }, [setAuthState]);

    // Persist updates to localStorage
    const setAuth = (accessToken?: string, operatorId?: string) => {
        const newState = { ...auth, accessToken, operatorId };
        localStorage.setItem('userState', JSON.stringify(newState));
        setAuthState(newState);
    };

    return {
        ...auth,
        setAuth,
    };
};
